module.exports = __webpack_public_path__ + "img/spitter-die-2.d512a934.png";